<template>
    <div>
        <div style="width: 100%;margin-bottom: 20px;">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/user/user' }">用户管理</el-breadcrumb-item>
                <!-- <el-breadcrumb-item>{{tableData.user.username}}的详细信息</el-breadcrumb-item> -->
            </el-breadcrumb>
        </div>
    
        <el-divider content-position="left" class="title">基本信息</el-divider>
        
        <el-card class="box-card">
        <el-row :gutter="20" v-if="tableData">
            <el-col :span="4">
                <el-avatar :size="100" >
                    <img :src="tableData.face"/>
                </el-avatar>
            </el-col>
            <el-col :span="10">
                <div class="marginB-10">id:{{tableData.uid}}</div>
                <div class="marginB-10">账号:{{tableData.username?tableData.username:'暂未设置'}}</div>
                <div class="marginB-10">真实姓名:{{tableData.nickname?tableData.nickname:'暂未设置'}}</div>
                <div class="marginB-10" v-if="tableData.parentId">上级：{{tableData.parentUser.username}}</div>
                <div class="marginB-10">等级:{{tableData.agentName}}</div>
            </el-col>
            <el-col :span="10">
                <div class="marginB-10">手机号码:{{tableData.mobile?tableData.mobile:'暂未设置'}}</div>
                <div class="marginB-10">收货地址:{{tableData.address?tableData.address:'暂未设置'}}</div>
                
            </el-col>
            </el-row>   
        </el-card>
        <el-divider content-position="left" class="title">客户资料</el-divider>
        
        <el-card class="box-card">
        <el-row :gutter="20">
            <el-col :span="8">
                <div>性别:{{tableData.sex==1?'男':tableData.sex==0?'女':'保密'}}</div>
            </el-col>
            <el-col :span="8">
                <div>生日:{{tableData.birthday?tableData.birthday:'暂未设置'}}</div>
              
            </el-col>
            <el-col :span="8">
                <div>邀请方:{{tableData.parentUser&&tableData.parentUser.username?tableData.parentUser.username:'未绑定上级'}}</div>            
            </el-col>
            </el-row>   
        </el-card>
        <el-divider content-position="left" class="title">客户标签</el-divider>
        
        <el-card class="box-card">
            <div  v-if="tableData.userTags&&tableData.userTags.length">
                <el-tag type="success" v-for="item in tableData.userTags" :key="item.id"  closable @close="delUserTag(item,tableData.username)">{{item.tagName}}</el-tag>

            </div>
            <div v-else>
                暂未设置
            </div>
        </el-card>

        <!-- <el-divider content-position="left" class="title">交易统计</el-divider>
        <el-card class="box-card">
         
            <div >
                暂未设置
            </div>
        </el-card> -->

        <el-divider content-position="left" class="title">资产信息</el-divider>
        <el-card class="box-card">
            <el-row :gutter="20" v-if="tableData.userAsset">
                <!-- <el-col :span="8">
                    <div>可用积分:{{tableData.user.sex==1?'男':tableData.user.sex==0?'女':'保密'}}</div>
                </el-col> -->
                <el-col :span="8">
                    <div>可用余额:{{tableData.userAsset.balance?tableData.userAsset.balance:'0'}}</div>
                  
                </el-col>
               
                </el-row>   
        </el-card>


    </div>
</template>

<script>
  
    import {  getUserInfo , delUserTag } from '../../api/basisMG.js'
 
  
    // 导出模块
    export default {
    
        // 模块数据
        data() {
            //数据  
            return {       
                loading: false,
                visible: false,
                listData: [],          
                dialogVisible: false,
                tagId:'',
                name:'',
                tableData:{},
                uid:''
            }
        },


        watch: {},

        methods: {
              // 删除用户标签val
              delUserTag(val,username) {
                  console.log(val)
                  let msg = '确认删除用户'+ username+'的'+val.tagName + '标签?'
                this.$confirm(msg, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delUserTag({
                        uids:this.tableData.uid,
                        tagId:val.tagId
                    }).then(res => {
                    if (res.code == '200') {
                        this.getsingleUserInfo({uid:this.uid})
                        this.tagList = res.data
                    }
                })
                })
               
            },
            showPop(){
                this.visible = true
                console.log(111)
            },
           
              // 获取会员详细信息
              getsingleUserInfo(row){
                getUserInfo(row).then(res => {
                    if (res.code == '200') {
                        this.tableData = res.data
                       console.log(res.data)
                     
                    }
                })
            },
         
        },
        // 创建前状态(里面是操作)
        beforeCreate() { 
          
        },
        // 创建完毕状态(里面是操作)
        created() {
            let uid =  this.$route.query.uid
            this.uid =uid
            console.log(uid)
            this.getsingleUserInfo({uid}) 
        },
        // 挂载前状态(里面是操作)
        beforeMount() { },
        // 挂载结束状态(里面是操作)
        mounted() { },
        // 更新前状态(里面是操作)
        beforeUpdate() { },
        // 更新完成状态(里面是操作)
        updated() { },
        // 销毁前状态(里面是操作)
        beforeDestroy() { },
        // 销毁完成状态(里面是操作)
        destroyed() { }
    };
</script>

<style scoped>
    .el-form-item {
        width: 40%;
        box-sizing: border-box;
    }

    .just-start {
        display: flex;
        justify-content: flex-start;
    }

    .marginT20 {
        margin-top: 20px;
    }
    .title{
        font-size: 30px;
        font-weight: bold;
        color: #000;
    }
    .contian{
        display: flex;
    }
    div{
        color: #303133;
    }
    .marginB-10{
        margin-bottom: 10px;
    }
</style>